import {CSVReader} from 'react-papaparse'
import {useContext, useRef, useState} from "react";
import {postForm} from '../../utils/postForm';
import {ApplicationContext} from "../../state/applicationState";
import {Company} from "../company";


export const TrackedCallsUpload = () => {
    const {currentCompany} = useContext(ApplicationContext)
    const buttonRef = useRef(null)
    const [key, setKey] = useState("")
    const [selectedFile, setSelectedFile] = useState<undefined | File>(undefined);


    const handleSubmit = async (e: any) => {
        e.preventDefault()
        if (!selectedFile) {
            return
        }
        console.log(selectedFile);
        const formData = new FormData();
        formData.append("name", "file");
        if (selectedFile) {
            formData.append("bulkUpload", selectedFile);
        }
        const response = await fetch(`${process.env.REACT_APP_API}/v1/api/upload/upload-csv?key=${key}`, {
            method: "POST",
            body: formData,
            credentials: "include",
        })
        const read = await response.json();
        console.log("read is", read)
        window.alert(read.message);
    }

    const addFile = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files) {
            return;
        }
        setSelectedFile(e.target.files[0]);
    };

    // @ts-ignore
    const handleOnError = (err, file, inputElem, reason) => {
        window.alert(err)
    }

    const handleFileLoad = async (data: any) => {
        let resp = await postForm(`/v1/api/internal-upload/${currentCompany.UUID}/phone-calls-from-google`, JSON.stringify(data))
        console.log("response is", resp.responseMessage);
        if (!resp.isOk) {
            window.alert(resp.responseMessage.message);
        } else {
            window.alert(resp.responseMessage.message);
        }
        setKey("")
    }

    return (
        <div>
            <h1 className={"text-3xl font-bold text-blueGray-700 mb-10"}>Upload Call Extension Phone Calls</h1>
            <div className={"text-xl space-y-4 mb-8"}>
                <p>Upload Style (order matters)</p>
                <p>Phone Number | Start Time | Ad Group | Campaign | Search Keyword</p>
            </div>
            <CSVReader
                ref={buttonRef}
                onError={handleOnError}
                onFileLoad={handleFileLoad}
            >
                <button className={"mx-auto text-3xl bg-blue-300 px-12 py-4 rounded-2xl shadow-xl"}>Upload a File
                </button>
            </CSVReader>
            <div className={"mt-24"}>
                <hr className={"my-6"}/>
                <Company/>
            </div>

        </div>
    )
}